import { useParams } from "@tanstack/react-router"

import { MainPortalPage } from "@/screens/settings/portal-instance/main-portal-page"
import { NewPortalPage } from "@/screens/settings/portal-instance/new-portal-page"
import { PortalDetailPage } from "@/screens/settings/portal-instance/portal-detail-page"

// One route serves all three, so none shows up as a standalone settings nav page.
export function PortalInstanceSettingsPage() {
	const { portalId } = useParams({ strict: false })
	if (portalId === "new") return <NewPortalPage />
	if (portalId === "main") return <MainPortalPage />
	return <PortalDetailPage />
}
